import { render, staticRenderFns } from "./TenantAccessAddress.vue?vue&type=template&id=2bc3cbeb&scoped=true&"
import script from "./TenantAccessAddress.vue?vue&type=script&lang=js&"
export * from "./TenantAccessAddress.vue?vue&type=script&lang=js&"
import style0 from "./TenantAccessAddress.vue?vue&type=style&index=0&id=2bc3cbeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3cbeb",
  null
  
)

export default component.exports